/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import userProfiler from "../modules/userprofiler";
import browser from "../utils/browser";

export default baustein.register("email-capture-page", {
    defaultOptions: {
        captureType: "unknown"
    },

    init() {
        if (!this.isMobile()) {
            return;
        }

        // else email-capture-overlay does this
        var email = userProfiler.userProfile.user.email;
        if (email) {
            this.setEmailAddress(email);
        }
    },

    setEmailAddress(emailAddress) {
        const input = this.el.querySelector('input[name="email"]');
        if (input) {
            input.value = emailAddress;
        }
    },

    isMobile() {
        return browser.getViewport() === browser.VIEWPORTS.MOBILE;
    }
});

